import classnames from 'classnames';
import React, { HTMLAttributes } from 'react';
import './index.less';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    /**
     * 自定义icon
     */
    indicator?: React.ReactNode;
    tip?: string;
}

const Loading = (props: IProps) => {
    const { style, className, indicator, tip } = props;

    return (
        <div className={classnames('b-loading-component', className)} style={{ ...style }}>
            <div className="b-loading-component__icon">
                {indicator ? (
                    indicator
                ) : (
                    <div className="loading-wrap">
                        <span className="content"></span>
                    </div>
                )}
            </div>
            {tip ? <div className="b-loading-component__tip">{tip}</div> : null}
        </div>
    );
};

export default Loading;
